import React from 'react'

export function TableTrainerPlayer({ x, y, role, bgPos, isFold, effStack, position, playerAction, posFontColor }) {
	const opacity = isFold ? '0.3' : '1'

	const card = (
		<svg width='56' height='30' viewBox='0 0 56 30' fill='none' xmlns='http://www.w3.org/2000/svg'>
			<g clipPath='url(#clip0_3274_50725)'>
				<path
					d='M53.9856 0H2.0144C0.901878 0 0 0.901878 0 2.0144V27.9856C0 29.0981 0.901878 30 2.0144 30H53.9856C55.0981 30 56 29.0981 56 27.9856V2.0144C56 0.901878 55.0981 0 53.9856 0Z'
					fill='#2D3036'
				/>
				<path
					d='M72.7635 39.2943L75.8043 27.9449L78.8451 39.2943L77.4184 44.6193C78.3564 44.1065 79 43.1228 79 41.9784V34.0725L76.5814 25.0446L79 16.0171V5.57205L77.6416 0.50205C77.1643 0.18615 76.5936 0 75.9783 0H75.9531L78.8451 10.7946L75.8044 22.1444L72.7638 10.7946L75.6558 0H74.1016L71.3046 10.4404L68.5075 0H66.9534L69.8454 10.7946L66.8047 22.1444L63.7641 10.7946L66.6561 0H65.1019L62.3049 10.4404L59.5078 0H57.9537L60.8457 10.7946L57.805 22.1444L54.7644 10.7946L57.6564 0H56.1022L53.3052 10.4404L50.5082 0H48.954L51.846 10.7946L48.8054 22.1444L45.7647 10.7946L48.6567 0H47.1026L44.3055 10.4404L41.5085 0H39.9543L42.8463 10.7946L39.8057 22.1444L36.765 10.7946L39.657 0H38.1029L35.3058 10.4404L32.5088 0H30.9546L33.8466 10.7946L30.806 22.1444L27.7653 10.7946L30.6573 0H29.1032L26.3061 10.4404L23.5091 0H21.955L24.8469 10.7946L21.8063 22.1444L18.7657 10.7946L21.6577 0H20.1035L17.3065 10.4404L14.5072 0H12.953L15.845 10.7946L12.8044 22.1444L9.76372 10.7946L12.6556 0H11.1014L8.30438 10.4404L5.50718 0H3.95303L6.84503 10.7946L3.80438 22.1444L0.76374 10.7946L3.65559 0H2.10144L-0.695608 10.4404L-3.39425 0.36765C-3.91475 0.6462 -4.3397 1.0683 -4.622 1.58655L-2.15495 10.7946L-5 21.414V28.6749L-2.15495 39.2942L-3.5609 44.5419C-3.1394 44.8028 -2.6507 44.9594 -2.12495 44.9852L-0.695608 39.6502L0.73779 45H2.29239L0.76374 39.2943L3.80453 27.9449L6.84533 39.2943L5.31668 45H6.87128L8.30468 39.6502L9.73807 45H11.2927L9.76402 39.2943L12.8048 27.9449L15.8456 39.2943L14.317 45H15.8716L17.305 39.6502L18.7384 45H20.293L18.7643 39.2943L21.8051 27.9449L24.8459 39.2943L23.3173 45H24.8718L26.3052 39.6502L27.7386 45H29.2932L27.7646 39.2943L30.8054 27.9449L33.8462 39.2943L32.3175 45H33.8721L35.3055 39.6502L36.7389 45H38.2935L36.7649 39.2943L39.8057 27.9449L42.8465 39.2943L41.3178 45H42.8724L44.3058 39.6502L45.7392 45H47.2938L45.7652 39.2943L48.806 27.9449L51.8467 39.2943L50.3181 45H51.8727L53.3061 39.6502L54.7395 45H56.2941L54.7654 39.2943L57.8062 27.9449L60.847 39.2943L59.3184 45H60.873L62.3064 39.6502L63.7398 45H65.2944L63.7657 39.2943L66.8065 27.9449L69.8473 39.2943L68.3187 45H69.8733L71.3067 39.6502L72.7401 45H74.2947L72.766 39.2943H72.7635ZM-0.695608 38.9412L-4.4186 25.0446L-0.695608 11.1488L3.02739 25.0446L-0.695608 38.9412V38.9412ZM8.30438 38.9412L4.58138 25.0446L8.30438 11.1488L12.0274 25.0446L8.30438 38.9412V38.9412ZM17.3044 38.9412L13.5814 25.0446L17.3044 11.1488L21.0274 25.0446L17.3044 38.9412V38.9412ZM26.3043 38.9412L22.5814 25.0446L26.3043 11.1488L30.0273 25.0446L26.3043 38.9412V38.9412ZM35.3043 38.9412L31.5813 25.0446L35.3043 11.1488L39.0273 25.0446L35.3043 38.9412V38.9412ZM44.3043 38.9412L40.5813 25.0446L44.3043 11.1488L48.0273 25.0446L44.3043 38.9412V38.9412ZM53.3043 38.9412L49.5813 25.0446L53.3043 11.1488L57.0273 25.0446L53.3043 38.9412V38.9412ZM62.3043 38.9412L58.5813 25.0446L62.3043 11.1488L66.0273 25.0446L62.3043 38.9412V38.9412ZM67.5813 25.0446L71.3043 11.1488L75.0273 25.0446L71.3043 38.9412L67.5813 25.0446Z'
					fill='#43506A'
				/>
				<path
					d='M53.9856 1.5C54.2693 1.5 54.5 1.7308 54.5 2.0144V27.9856C54.5 28.2693 54.2692 28.5 53.9856 28.5H2.0145C1.7308 28.5 1.5 28.2692 1.5 27.9856V2.0145C1.5 1.7308 1.7308 1.5001 2.0145 1.5001H53.9856M53.9856 0H2.0145C0.9019 0 0 0.9019 0 2.0145V27.9856C0 29.0981 0.9019 30 2.0145 30H53.9856C55.0981 30 56 29.0981 56 27.9856V2.0145C56 0.9019 55.0981 0 53.9856 0Z'
					fill='#686E7B'
				/>
				<path
					d='M51.2468 2.99072C51.9292 2.99072 52.4844 3.54592 52.4844 4.22832V25.7531C52.4844 26.4355 51.9292 26.9907 51.2468 26.9907H4.72198C4.03958 26.9907 3.48438 26.4355 3.48438 25.7531V4.22832C3.48438 3.54592 4.03958 2.99072 4.72198 2.99072H51.2468M51.2468 2.49072H4.72198C3.76228 2.49072 2.98438 3.26872 2.98438 4.22832V25.7531C2.98438 26.7128 3.76238 27.4907 4.72198 27.4907H51.2468C52.2065 27.4907 52.9844 26.7127 52.9844 25.7531V4.22832C52.9844 3.26862 52.2064 2.49072 51.2468 2.49072Z'
					fill='#686E7B'
				/>
			</g>
			<defs>
				<clipPath id='clip0_3274_50725'>
					<rect width='56' height='30' fill='white' />
				</clipPath>
			</defs>
		</svg>
	)

	return (
		<>
			<svg
				id='parent'
				y={y}
				x={x}
				width='87'
				height='90'
				style={{
					strokeDasharray: role === 'hero' && 1000,
					strokeDashoffset: role === 'hero' && 1000,
					zIndex: 100,
				}}
			>
				<svg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 154.9 109.1' id={'zxc'}>
					<style>{` .st0{fill:#292C3D;}.st1{fill:#292C3D;} .st2{fill:rgb(56,177,111);}`}</style>

					{!isFold && ( // значки карт над позицией
						<>
							<foreignObject width={56} height={30} x={20} y='32%'>
								{card}
							</foreignObject>

							<foreignObject width={56} height={30} x={79} y='32%'>
								{card}
							</foreignObject>
						</>

						// <svg xmlns='http://www.w3.org/2000/svg' y='15%'>
						// 	<g>
						// 		<rect x='7.2' y='25.1' fill={'#323549'} width='70' height='25.4' rx={2} />
						//
						// 		<rect x='78.2' y='25.1' fill={'#323549'} width='70' height='25.4' rx={2} />
						// 	</g>
						// </svg>
					)}

					<rect x='3.2' y='58.1' className='st0' width='149.1' height='25.4' />
					<rect x='3.2' y='82.5' style={{ fill: '#292C3D' }} width='149.1' height='34' />
					<rect x='5.2' y='82.5' className='st1' width='100.1' height='24.4' />
					<rect x='79.1' y='58.1' className='st1' width='0.5' height='24.6' />

					{/* Действие */}
					<text style={{ opacity }} x='10' y='108' fontWeight='400' fontSize='1rem' fill={'#fff'}>
						{isFold ? 'Fold' : playerAction}
					</text>

					{/* Плашка позиции */}
					<svg xmlns='http://www.w3.org/2000/svg' x='10' y='24' width={65}>
						<g>
							<g>
								<rect width='65' height='27' x={0} y={38} rx='2' style={{ fill: bgPos, opacity }} />

								<text
									x='50%'
									y='49%'
									fontWeight='500'
									fill='#000'
									dominantBaseline='middle'
									textAnchor='middle'
									fontSize='1.4rem	'
									style={{ fill: posFontColor }}
								>
									{position}
								</text>
							</g>
						</g>
					</svg>

					{/* Stack */}
					<text
						x={effStack && effStack >= 100 ? '90' : '100'}
						y='81'
						fontWeight='400'
						fill='#fff'
						fontSize='1rem'
						style={{ opacity }}
					>
						{effStack && Math.abs(effStack).toFixed(2)}
					</text>
				</svg>
			</svg>
		</>
	)
}
